<template>
  <div
    class="row mx-3 p-4 bg-secondary-3 border-left--color-gray border-left-3 rounded"
  >
    <div class="col-12 px-0 d-flex mb-2">
      <span
        class="dot-small text-center d-flex align-items-center justify-content-center mr-2"
      >
        <i
          class="orange-icon orange-icon-badge-align fas fa-long-arrow-right text-green"
        />
      </span>

      <span class="font-weight-bold">{{ title }}</span>
    </div>
    <div class="col-12">
      <label class="form-label color-gray--6">{{ label }}</label>
      <CustomTextArea
        v-model="value"
        regular-label
        :disabled="readonly"
        :maxlength="3000"
        show-char-count
        :count-classes="['d-none text-right']"
      />
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
export default {
  name: 'TextAreaSection',
  components: {
    CustomTextArea,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.dot-small {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  opacity: 1;
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
}
.border-left-3 {
  border-left: 3px solid;
}
</style>
